import { useResetAtom } from 'jotai/utils';
import { useAccountsResetAtoms } from 'views/sast2/Accounts/state';
import { useRepositoryResetAtoms } from 'views/sast2/Repositories/state';

import { sastTypeAtom, appliedRowIdsAtom } from '../SASTDashboard2/state';

export function useOnCompanyChangeSast2ResetAtoms() {
  const resetAppliedRowIdsAtom = useResetAtom(appliedRowIdsAtom);
  const resetSastTypeAtom = useResetAtom(sastTypeAtom);
  const resetRepositoryAtoms = useRepositoryResetAtoms();
  const resetAccountsAtoms = useAccountsResetAtoms();

  const resetAtoms = () => {
    resetAppliedRowIdsAtom();
    resetSastTypeAtom();
    resetRepositoryAtoms();
    resetAccountsAtoms();
  };

  return resetAtoms;
}
